import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { infinitivesData, getDataForDifficulty } from '../courses/data/grammar/infinitives';

export default function InfinitiveTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : infinitivesData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
